export const POLYGON_COLORS = {
  HOVER: {
    FILL: "rgba(248, 207, 0, 0.35)",
    STROKE: "rgba(248, 207, 0, 1)",
  },
  DEFAULT: {
    FILL: "rgba(0, 123, 255, 0.25)",
    STROKE: "rgba(0, 123, 255, 1)",
  },
  SELECTED: {
    FILL: "rgba(248, 207, 0, 0.35)",
    STROKE: "rgba(248, 207, 0, 1)",
  },
};

export const ZONE_POLYGON_COLORS = {
  DEFAULT: {
    FILL: "rgba(0, 255, 127, 0.25)",
    STROKE: "#00FF7F",
    TEXT: "#E0F6FF",
    SHADOW: "#001",
  },
  HIGHLIGHTED: {
    FILL: "rgba(255, 140, 0, 0.4)",
    STROKE: "#FF8C00",
    TEXT: "#ffffff",
    SHADOW: "#000",
  },
};

export const GONDOLA_COLORS = {
  HOVER: "#FFB800",
  DEFAULT: "#2563eb",
};
